import { render, staticRenderFns } from "./DriverVehicle.vue?vue&type=template&id=d6ddbe4e&transition=scale-transition&origin=center%20center&"
import script from "./DriverVehicle.vue?vue&type=script&lang=js&"
export * from "./DriverVehicle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports